import React, { FC } from 'react';
import { Tabs as AntdTabs } from 'antd';
import { TabsProps } from 'antd/lib/tabs';

export const Tabs: FC<TabsProps> = (props) => {
  return <AntdTabs {...props} />;
};
export default Tabs;
